export default function ({ store, redirect }) {
    if (!store.state?.application?.driver?.authUser) {
        return redirect('/shop');
    } else if (!store.state?.application?.driver?.authUser?.isReferralLinkActive) {
        return redirect('/dashboard');
    }
}
